function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 0.75,
  y: 0.75,
  width: 26.5,
  height: 46.5,
  rx: 4.25,
  fill: "#F0F4F8",
  stroke: "#6B7588",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 3.864,
  y: 19.2,
  width: 20,
  height: 6.982,
  rx: 1,
  fill: "#6B7588"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  width: 12,
  height: 2.182,
  rx: 1,
  fill: "#6B7588"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.008 16.263c-.424 0-.768-.176-1.128-.48l-.32.48c.416.336.864.552 1.44.552 1.232 0 2.064-1.152 2.064-3.048v-.064c0-1.168-.248-1.784-.648-2.176-.304-.312-.712-.488-1.232-.488-1.024 0-1.768.808-1.768 1.896v.016c0 1.08.736 1.744 1.696 1.744.592 0 1.056-.304 1.352-.784-.008 1.32-.536 2.352-1.456 2.352zm.176-2.088c-.672 0-1.16-.488-1.16-1.248v-.016c0-.736.432-1.336 1.144-1.336.736 0 1.208.568 1.208 1.32v.024c0 .712-.488 1.256-1.192 1.256zm2.884-.792h.712v-.824h-.712v.824zm0 3.344h.712v-.824h-.712v.824zm4.236 0h.568v-1.296h.744v-.512h-.744v-3.832h-.528l-2.72 3.904.112.44h2.568v1.296zm-2-1.808l2-2.888v2.888h-2zm4.748 1.808h.592v-5.632h-.448l-1.16.44.104.52.912-.328v5z",
  fill: "#6B7588"
});

function SvgBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgBackground;